var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.3334L17.5 10M17.5 10L14.1667 6.66671M17.5 10H5.83333M10.8333 13.3334V14.1667C10.8333 14.8297 10.5699 15.4656 10.1011 15.9345C9.63226 16.4033 8.99637 16.6667 8.33333 16.6667H5C4.33696 16.6667 3.70107 16.4033 3.23223 15.9345C2.76339 15.4656 2.5 14.8297 2.5 14.1667V5.83337C2.5 5.17033 2.76339 4.53445 3.23223 4.06561C3.70107 3.59677 4.33696 3.33337 5 3.33337H8.33333C8.99637 3.33337 9.63226 3.59677 10.1011 4.06561C10.5699 4.53445 10.8333 5.17033 10.8333 5.83337V6.66671",
    stroke: "#363333",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/logouticon.92b23feb2d0ce09abc2065aa70888524.svg";
export { ForwardRef as ReactComponent };